import { useOptionalFeatureFlagContext } from '../featureFlags/featureFlagContext';
import { GOOGLE_BASEMAP_FLAG, isGoogleBasemapActive } from './basemap';
import { getGoogleMapsBrowserKey } from './session';

export interface GoogleBasemapState {
  active: boolean;
  apiKey: string | null;
}

export function useGoogleBasemap(): GoogleBasemapState {
  const flags = useOptionalFeatureFlagContext();
  const apiKey = getGoogleMapsBrowserKey();
  const active = isGoogleBasemapActive(flags?.isEnabled(GOOGLE_BASEMAP_FLAG) ?? false, apiKey);
  return { active, apiKey: active ? apiKey : null };
}
